import { UIRouterReact, UISref } from '@uirouter/react';

const ROUTER_CONST = {};
ROUTER_CONST.STATE_VISIBILITY_PUBLIC    = 'public';
ROUTER_CONST.STATE_VISIBILITY_PRIVATE   = 'private';
ROUTER_CONST.STATE_VISIBILITY_PROTECTED = 'protected';

const router     = new UIRouterReact();
let $state       = router.stateService;
let $stateParams = router.globals.params;

export {
	ROUTER_CONST,
    router,
    $state,
    $stateParams,
    UISref
};

export default router;